module.exports = __webpack_public_path__ + "static/media/993280.61598d42.svg";